/** Lowest to highest (rules §3.1): ♣ ♦ ♥ ♠, No Trumps, All Trumps. */
export const BELOT_MODES = ['C', 'D', 'H', 'S', 'NT', 'AT'];
//# sourceMappingURL=types.js.map